<ng-container *transloco="let t; read: 'ime.manufacturing.integrated-master-editor'">
  <td class="mes-conf group" [attr.rowspan]="nrOfInstructionsInTaskSelector" *ngIf="taskSelector && masterOutputInstruction.TaskSelectorId && index === 0">
    <ime-task-selector-cell [taskSelector]="taskSelector" [masterOperation]="masterOperation" [readonly]="readonly" (changed)="changed.emit()"></ime-task-selector-cell>
  </td>
  <td class="materials mes-conf" [attr.colspan]="!settings.TaskSelector ? 1 : masterOutputInstruction.TaskSelectorId ? 1 : 2">
    <div *ngIf="masterOutputInstruction.Sequence" class="cell-badge badge bg-default" title="{{t('Sequence')}}: {{masterOutputInstruction.Sequence}}">
      {{masterOutputInstruction.Sequence}}
    </div>
    <div class="cell-action" ngbDropdown #editDropdown="ngbDropdown" contenteditable="false" container="body" [autoClose]="'outside'">
      <button class="btn btn-outline-default btn-sm dropdown-toggle" tabindex="-1" type="button" ngbDropdownToggle>±</button>
      <div class="dropdown-menu position-absolute" ngbDropdownMenu role="menu">
        <ng-container *ngIf="!readonly">
          <a class="dropdown-item" (click)="integratedMasterService.addMasterUseInstructionAfter(masterOperation, masterOperation.getLastUseInstruction()); changed.emit(); editDropdown.close()">
            {{t('Add resource usage')}}
          </a>
          <a class="dropdown-item" (click)="integratedMasterService.addMasterInputInstructionAfter(masterOperation, masterOperation.getLastInputInstruction()); changed.emit(); editDropdown.close()">
            {{t('Add item usage')}}
          </a>
          <a class="dropdown-item" (click)="integratedMasterService.addMasterOutputInstructionAfter(masterOperation, masterOutputInstruction); changed.emit(); editDropdown.close()">
            {{t('Add process result')}}
          </a>
          <div *ngIf="settings.TaskSelector" ngbDropdown class="dropdown-item">
            <button type="button" class="btn btn-link p-0" ngbDropdownToggle>{{t('Task selector')}}: {{taskSelector?.Code}}</button>
            <div ngbDropdownMenu>
              <button type="button" ngbDropdownItem (click)="addNewTaskSelector(); editDropdown.close()">{{t('Add Task selector')}}</button>
              <button type="button" ngbDropdownItem *ngFor="let ts of masterOperation.TaskSelectors | orderBy: 'Code'" (click)="changeSelector(ts); editDropdown.close()">
                <span [class.fw-bold]="ts.Id === taskSelector?.Id">{{ts.Code}}</span>
              </button>
            </div>
          </div>
          <a class="dropdown-item" (click)="edit(); editDropdown.close()">
            {{t('Edit')}} {{masterOutputInstruction.Code}}
          </a>
          <div class="d-flex dropdown-item">
            <label class="col-form-label me-2">{{t('Sequence')}}</label>
            <div class="col-6">
              <input type="number" class="form-control" id="Sequence-{{masterOutputInstruction.Id}}" name="Sequence-{{masterOutputInstruction.Id}}" [(ngModel)]="masterOutputInstruction.Sequence">
            </div>
          </div>
          <div class="d-flex dropdown-item flex-wrap">
            <label class="col-form-label col-12 me-2 pt-0">{{t('Source Code')}}</label>
            <div class="col-12">
              <input type="text" class="form-control" id="SourceCode-{{masterOutputInstruction.Id}}" name="SourceCode-{{masterOutputInstruction.Id}}" [(ngModel)]="masterOutputInstruction.SourceCode">
            </div>
          </div>
          <div ngbDropdown class="dropdown-item">
            <button type="button" class="btn p-0" ngbDropdownToggle>{{t('Delete')}}</button>
            <div ngbDropdownMenu>
              <button type="button" ngbDropdownItem class="text-danger" (click)="integratedMasterService.removeMasterOutputInstruction(masterOperation, masterOutputInstruction); changed.emit(); editDropdown.close()">
                {{t('Delete')}} {{masterOutputInstruction.Code}}
              </button>
              <ng-container *ngLet="(masterOperation.MasterOutputInstructions | where : 'TaskSelectorId' : masterOutputInstruction.TaskSelectorId : true) as moisInTs">
                <button type="button" ngbDropdownItem class="text-danger" (click)="integratedMasterService.removeMasterOutputInstructions(masterOperation, moisInTs); changed.emit(); editDropdown.close()" *ngIf="moisInTs.length > 1">
                  {{t('Delete')}} <span *ngFor="let moiInTs of moisInTs; let last = last">{{moiInTs.Code}}<ng-container *ngIf="!last">, </ng-container></span>
                </button>
              </ng-container>
            </div>
          </div>
        </ng-container>
        <app-copy-paste-menu-item [allowCopyAll]="masterOperation.MasterOutputInstructions.length > 1" [readonly]="readonly"
                                      (onCopy)="copyPasteService.copy('MasterOutputInstruction', [masterOutputInstruction]); editDropdown.close()"
                                      (onCopyAll)="copyPasteService.copy('MasterOutputInstruction', masterOperation.MasterOutputInstructions); editDropdown.close()"
                                      (onPaste)="paste(masterOperation); editDropdown.close()"
                                      (onClipboardPaste)="paste(masterOperation, true); editDropdown.close()"></app-copy-paste-menu-item>
      </div>
    </div>
    <span *ngIf="!readonly" class="edit-container" name="moi-Code-{{masterOutputInstruction.Id}}" contenteditable [(ngModel)]="masterOutputInstruction.Code" strip-br="true"></span>
    <span *ngIf="readonly">{{masterOutputInstruction.Code}}</span>
    <app-source-code-view [code]="masterOutputInstruction.Code" [sourceCode]="masterOutputInstruction.SourceCode"></app-source-code-view>
    <span class="badge rounded-pill bg-light text-dark" title="Alternative" *ngIf="isAlternative">ALT</span>
  </td>
  <td pEditableColumn class="materials" mesStopClickPropagation>
    <p-cellEditor mesStopDragPropagation>
      <ng-template pTemplate="input">
        <ng-container *ngIf="readonly; else selectOutput">
          <div class="bl-3 border-primary ps-1" *ngIf="masterOutputInstruction.ItemGroupId">
            <a href="javascript:void(0)" (click)="openItemGroupEditModal(masterOutputInstruction.ItemGroupId)">
              {{itemGroupService.query.selectEntity(masterOutputInstruction.ItemGroupId) | async | displayName}}
            </a>
          </div>
          <div class="bl-3 border-secondary ps-1" *ngIf="masterOutputInstruction.ItemId">
            <a href="javascript:void(0)" (click)="openItemEditModal(masterOutputInstruction.ItemId)">
              {{itemService.query.selectEntity(masterOutputInstruction.ItemId) | async | displayName}}
            </a>
          </div>
        </ng-container>
        <ng-template #selectOutput>
          <div class="bl-3 border-primary mb-1" *ngIf="allowItemGroupsAsOutputs">
            <mes-web-manufacturing-item-group-select name="masterOutputInstruction-Item-Group-Id-{{masterOutputInstruction.Id}}"
                                                     [entityId]="masterOutputInstruction.ItemGroupId"
                                                     [items$]="itemGroupService.getAll$"
                                                     (entityIdChange)="masterOutputInstruction.ItemGroupId = $event; changed.emit()"></mes-web-manufacturing-item-group-select>
          </div>
          <div class="bl-3 border-secondary">
            <mes-web-manufacturing-item-select name="masterOutputInstruction-Item-Id-{{masterOutputInstruction.Id}}"
                                               [entityId]="masterOutputInstruction.ItemId"
                                               [items$]="itemService.getAll$"
                                               (entityIdChange)="masterOutputInstruction.ItemId = $event; changed.emit()"></mes-web-manufacturing-item-select>
          </div>
        </ng-template>
      </ng-template>
      <ng-template pTemplate="output">
        <div class="bl-3 border-primary ps-1 mb-1" *ngIf="masterOutputInstruction.ItemGroupId">
          {{itemGroupService.query.selectEntity(masterOutputInstruction.ItemGroupId) | async | displayName}}
        </div>
        <div class="bl-3 border-secondary ps-1" *ngIf="masterOutputInstruction.ItemId">
          {{itemService.query.selectEntity(masterOutputInstruction.ItemId) | async | displayName}}
        </div>
      </ng-template>
    </p-cellEditor>
  </td>
  <td pEditableColumn class="materials cell-action-container">
    <p-cellEditor>
      <ng-template pTemplate="input">
        <input name="PreviousProcessNumber-{{masterOutputInstruction.Id}}" class="form-control content-editable border-0 bg-transparent" type="number" mesStopArrowKeyPropagation [(ngModel)]="masterOutputInstruction.PreviousProcessNumber" [readonly]="readonly"/>
      </ng-template>
      <ng-template pTemplate="output">
        {{masterOutputInstruction.PreviousProcessNumber}}
      </ng-template>
    </p-cellEditor>
  </td>
  <td app-expression-formula-cell class="materials" *ngIf="settings.Setup"
    [expression]="masterOutputInstruction.SetupRatio" [readonly]="readonly" (changed)="changed.emit(); masterOutputInstruction.SetupRatio = $event">
  </td>
  <td app-expression-formula-cell class="materials" [ngbTooltip]="masterOutputInstruction.ParentProductionRatio" container="body"
    [expression]="masterOutputInstruction.ProductionRatio" [readonly]="readonly" (changed)="changed.emit(); masterOutputInstruction.ProductionRatio = $event">
  </td>
  <td app-expression-formula-cell class="materials" *ngIf="settings.Teardown"
    [expression]="masterOutputInstruction.TeardownRatio" [readonly]="readonly" (changed)="changed.emit(); masterOutputInstruction.TeardownRatio = $event">
  </td>
  <td app-expression-formula-cell *ngIf="settings.ValidExpressions" class="materials cell-action-container" mesStopClickPropagation
    [expression]="masterOutputInstruction.ValidCondition" [readonly]="readonly" (changed)="changed.emit(); masterOutputInstruction.ValidCondition = $event">
  </td>
  <td class="materials mes-conf text-center" *ngIf="settings.ValidFromToDates">
    <ngbd-datepicker-range #validToFrom [fromDate]="masterOutputInstruction.ValidFrom" [toDate]="masterOutputInstruction.ValidTo"
                           (dateSelect)="masterOutputInstruction.ValidFrom = $event.From; masterOutputInstruction.ValidTo = $event.To"></ngbd-datepicker-range>
    <le-date-range-view [dateFrom]="masterOutputInstruction.ValidFrom" [dateTo]="masterOutputInstruction.ValidTo"></le-date-range-view>
    <div class="cell-action">
      <div class="btn btn-outline-default btn-sm icon" (click)="validToFrom.toggle()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#calendar-days">
        </svg>
      </div>
    </div>
  </td>
  <td class="materials mes-conf cell-action-container">
    <app-ime-spec-lines-view [specs]="masterOutputInstruction.Specs" [masterOperation]="masterOperation" [masterOutputInstructionModel]="masterOutputInstruction"
                             (changed)="masterOutputInstruction.Specs = $event; changed.emit(masterOutputInstruction)" [context]="masterOutputInstruction"></app-ime-spec-lines-view>
  </td>
  <td class="materials" *ngIf="settings.OperationSplitSizeMax"></td>
  <td class="materials cell-action-container" pEditableColumn>
    <p-cellEditor>
      <ng-template pTemplate="input">
        <input name="YieldRate-{{masterOutputInstruction.Id}}" class="form-control content-editable border-0 bg-transparent" [decimalPlaces]="6" [readonly]="readonly"
               [(mesNumberInput)]="masterOutputInstruction.YieldRate" (onChange)="changed.emit(masterOutputInstruction)">
      </ng-template>
      <ng-template pTemplate="output">
        {{masterOutputInstruction.YieldRate}}
      </ng-template>
    </p-cellEditor>
  </td>
  <td class="materials" *ngIf="settings.TimeConstraints"></td>
  <td class="materials" *ngIf="settings.TimeConstraints">
  </td>
  <td class="materials mes-conf" *ngIf="settings.TimeConstraints">
  </td>
</ng-container>
